import { render, staticRenderFns } from "./default.vue?vue&type=template&id=18075795"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsAppBar: require('/build/9a899117-d65d-4235-a376-21953085c465/nuxt/components/Layouts/AppBar.vue').default,LayoutsHolidayBanner: require('/build/9a899117-d65d-4235-a376-21953085c465/nuxt/components/Layouts/HolidayBanner.vue').default,LayoutsLoginBanner: require('/build/9a899117-d65d-4235-a376-21953085c465/nuxt/components/Layouts/LoginBanner.vue').default,LayoutsFooter: require('/build/9a899117-d65d-4235-a376-21953085c465/nuxt/components/Layouts/Footer.vue').default,VConsentSnackbar: require('/build/9a899117-d65d-4235-a376-21953085c465/nuxt/components/VConsentSnackbar.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VMain,VSnackbar})
